import { tribeEntityName } from '../../../backend/config/classifiers/entities/defineTribeClassifier';
import { t } from '../../../backend/utils/columnHandlerUtils';
import { getColumnValue, } from '@juvare/contact-management/backend/features/accounts/shared';
import { setDataValue } from '@juvare/json-data-util';
export const tribeColumnHandler = ({ context, column, sourceRow, targetRow }) => {
    const { action, value } = getColumnValue(sourceRow, column);
    const errors = [];
    const tribeStorage = context.storage(tribeEntityName);
    if (value && action === 'update') {
        const tribes = tribeStorage.list({
            filter: [
                { column: 'status', op: '=', value: 'active' },
                { column: 'name', op: '=', value },
            ],
            limit: 1,
        });
        if (!tribes.total) {
            errors.push(t('import.invalidClassifierName', {
                name: column.headerName.toLocaleLowerCase(),
                value,
            }));
        }
        setDataValue(targetRow, 'address.residenceType', 'tribe');
        setDataValue(targetRow, column.destination, tribes.rows[0].id);
    }
    else if (column.required) {
        errors.push(t('import.requiredField', { fieldName: column.headerName }));
    }
    return { errors };
};
